export const refIsNotNull = <T>(ref: React.MutableRefObject<T | null>):boolean => {
  return !!ref && !!ref.current && ref.current !== null;
};
